export const replaceSpacesAndSymbols = (input: string): string => {
  return input && input.replace(/[^a-zA-Z0-9\s]/g, "").replace(/\s+/g, "-");
};
